export const UserRoleEnumDto = {
    FieldTech: "field_tech",
    SuperUser: "super_user",
} as const;
export type UserRoleEnumDto =
    (typeof UserRoleEnumDto)[keyof typeof UserRoleEnumDto];
